import { render, staticRenderFns } from "./RecoverEmail.vue?vue&type=template&id=33adc093&scoped=true"
import script from "./RecoverEmail.vue?vue&type=script&lang=js"
export * from "./RecoverEmail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./RecoverEmail.vue?vue&type=style&index=2&id=33adc093&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33adc093",
  null
  
)

export default component.exports